import React from 'react';
import PillarPageTemplate from '../../components/PillarPageTemplate';
import { circulationMotoData } from '../../data/pillars/circulationMoto';

export default function PillarCirculationMoto() {
  return <PillarPageTemplate data={circulationMotoData} />;
}
